import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import { BasicFlex, InputLabel, LabelUpper } from '../../../utils/Common';

import { SearchPanel, ReportButton, ResultPanel, SummaryCard, SummaryAmount, TrajectoryIndicator, FilterRibbon } from '../Common';

import { Grid, Button, useTheme, Card, CardContent, CardHeader, Divider } from '@mui/material';

import AutoCompleteMulti from '../FilterFormComponents/AutocompleteMulti';
import DateRangePicker from '../FilterFormComponents/DateRangePicker';
import DatePicker from '../FilterFormComponents/DatePicker';
import RadioOptions from '../FilterFormComponents/RadioOptions';

import useReportStore from '../../../store/reports';

import { formatCurrency } from '../../../utils/util';

import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import Donut from '../../../utils/utilities/Charts/DonutChart';

import Lottie from '../../../utils/Lotties';
import LoadReportAnimation from '../../../assets/animations/Chart Grow Up.json';

import DetailedSales from './Detailed/Sales';


const SummaryCards = styled(BasicFlex)`

`;

const Categories = styled(Card)`
  /* min-width: 30rem; */
  /* width: 50%; */
  /* max-width: 65rem; */
`

const CatAmount = styled.div`
  font-weight: 500;
  font-size: 1.3rem;
`

const CatPer = styled.div`
  color: ${props => props.theme.colors.lightText};
`

const DetailedSection = styled(BasicFlex)`
  align-items: flex-start;
  gap: 2rem;
`

const categoryInfoLabel = (item, total) => {
  return (
    <BasicFlex dir="column" gap=".6rem">
      <BasicFlex gap=".6rem" justify="flex-start">
        <CatAmount>{formatCurrency(item.value)}</CatAmount> <CatPer>{Math.round((item.value / total) * 100)}%</CatPer>
      </BasicFlex>
      <div>Profit: {formatCurrency(item.profit)}</div>
    </BasicFlex>
  )
}

const SalesReport = () => {
  const reportType = useReportStore(state => state.reportType);
  const filters = useReportStore(state => state.filters);
  const staticFilters = useReportStore(state => state.staticFilters);
  const reportResults = useReportStore(state => state.reportResults);
  const reportLoading = useReportStore(state => state.reportLoading);

  const [category, setCategory] = useState(null);

  const handleCategorySelect = (item) => {
    let cat = item?.category
    setCategory(cat ?? null);
  }

  let dateRange = staticFilters[reportType]?.date || "";
  let customDate = dateRange === "Custom" ? true : false;
  console.log(filters, "filters");


  const isLoading = reportLoading[reportType];
  const results = reportResults[reportType];

  let totals = results?.totals || {};
  let categories = results?.by_category || [];

  const theme = useTheme();

  return (
    <>
    <SearchPanel>
      <Grid container spacing={2}>

        <Grid size={{xs: 12, md: 4}}>
          <InputLabel>Date Range</InputLabel>
          <DateRangePicker 
            field="date" 
          />
        </Grid>

       {customDate ? <Grid size={{xs: 12, md: 2}}>
          <InputLabel>Date From</InputLabel>
          <DatePicker 
            field="date" 
            type="start"
          />
        </Grid> : null}

        {customDate ? <Grid size={{xs: 12, md: 2}}>
          <InputLabel>Date To</InputLabel>
          <DatePicker 
            field="date" 
            type="end"
          />
        </Grid> : null}

        {/* <Grid size={{xs: 12, md: 4}}>
          <InputLabel>Sales Rep</InputLabel>
          <AutoCompleteMulti 
            field="rep" 
          />
        </Grid> */}

        <Grid size={{xs: 12, md: 4}}>
          <InputLabel>Accounting Type</InputLabel>
          <RadioOptions field="accounting_type" options={[ {value: "accrual", label: "Accrual"}, {value: "cash", label: "Cash Basis"}]} staticOption={true} defaultValue="accrual" />
        </Grid>

        <Grid size={{xs: 12}}>
          <ReportButton />
        </Grid>

      </Grid>
      
    </SearchPanel>

    <FilterRibbon />

    {isLoading ? <Lottie lottieFile={LoadReportAnimation} /> : null}

    {results && !isLoading ? <ResultPanel>
      <SummaryCards gap="2rem" justify="center">

        <SummaryCard $color={theme.colors.info} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Total Revenue</LabelUpper>
          <SummaryAmount>{formatCurrency(totals.revenue)}</SummaryAmount>
          {/* <TrajectoryIndicator value={12} /> */}
        </SummaryCard>

        <SummaryCard $color={theme.colors.primary} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Total Costs</LabelUpper>
          <SummaryAmount>{formatCurrency(totals.cogs)}</SummaryAmount>
          {/* <TrajectoryIndicator value={0} /> */}
        </SummaryCard>

        <SummaryCard $color={theme.colors.success} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Total Profit</LabelUpper>
          <SummaryAmount>{formatCurrency(totals.profit)}</SummaryAmount>
          {/* <TrajectoryIndicator value={8.5} /> */}
        </SummaryCard>

        <SummaryCard $color={theme.colors.warning} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Number of Invoices</LabelUpper>
          <SummaryAmount>{totals.invoice_count}</SummaryAmount>
          {/* <TrajectoryIndicator value={-4.2} /> */}
        </SummaryCard>
        
        <SummaryCard $color={theme.colors.secondary} dir="column" gap="1rem">
          <LabelUpper $size="1.3rem" $light>Unique Customers</LabelUpper>
          <SummaryAmount>{totals.customer_count}</SummaryAmount>
          {/* <TrajectoryIndicator value={0} /> */}
        </SummaryCard>

      </SummaryCards>

      <Categories elevation={3} sx={{width: "100%", borderRadius: "8px"}}>
        <CardHeader subheader="Total by Category" />
        <Divider />
        <Donut data={categories} additionalInfoLabel={categoryInfoLabel} categorySelect={handleCategorySelect} />
      </Categories>

      <DetailedSection>
        <DetailedSales category={category} />
      </DetailedSection>



    </ResultPanel> : null}
    </>
  )
};

export default SalesReport;